var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-0"},[_c('b-col',[_c('div',{attrs:{"id":"page-content"}},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }